import { Component, OnInit, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from './core/user.service';
import { BlendService } from './shared/services/blend.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from './reducers';
import { SentryService } from './core/sentry.service';
import { UnauthBlendService } from './shared/services/unauthblend.service';
import { ChameleonService } from './shared/services/chameleon.service';
import { ShareService } from './shared/services/share.service';
import { CrossDomainStateService } from './core/cross-domain-state.service';
import { AppVersionService } from './core/app-version.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  public title = 'cp';
  public routerSubscripion: Subscription;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private blendService: BlendService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private store: Store<fromRoot.State>,
    private sentryService: SentryService,
    private unauthBlendService: UnauthBlendService,
    private chameleonService: ChameleonService,
    private shareService: ShareService,
    private crossDomainStateService: CrossDomainStateService,
    private appVersionService: AppVersionService,
  ) {}

  public ngOnInit(): void {
    // Restore state from query params if present (for cross-domain redirects)
    this.crossDomainStateService.restoreStates();

    // By default Add the 'light' class to the body element
    this.renderer.addClass(document.body, 'light');

    // Detect new CP releases and offer a refresh prompt
    this.appVersionService.start();
  }

  public ngAfterViewInit(): void {
    this.routerSubscripion = this.router.events.subscribe((routeEvent) => {
      if (routeEvent instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if (!this.userService.isAuthenticated()) {
          // we only want to log 1% of all unauthenticated page views **unless** it's a shared folder invititation
          const isShareInvite = ['/shares', '/setuserinviteconsent', '/signup-share'].some((term) =>
            routeEvent.url.includes(term),
          );
          if (isShareInvite) {
            this.unauthBlendService.trackPageview();
          } else {
            const shouldLogPageView = Math.random() < 0.01;
            if (shouldLogPageView) {
              const isExcluded = routeEvent.url.startsWith('/dl/'); // unauthenticated publink views result in a lot of logging in Mixpanel
              if (!isExcluded) {
                this.unauthBlendService.trackPageview();
              }
            }
          }
        } else {
          this.blendService.trackPageview();
        }
      }
    });
    this.chameleonService.identify();
    if (this.userService.isAuthenticated()) {
      this.shareService.updateTheme();
    }
  }

  public ngOnDestroy(): void {
    if (this.routerSubscripion) {
      this.routerSubscripion.unsubscribe();
    }
  }
}
